import React from "react";

const PaperClipHome = ({
  width = 65,
  height = 64,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32.5"
        cy="32"
        r="31"
        fill="#2D96A7"
        fillOpacity="0.1"
        stroke="#2D96A7"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_1050_49676)">
        <path
          d="M36.4996 25.3326L27.8329 33.9993C27.3025 34.5297 27.0045 35.2492 27.0045 35.9993C27.0045 36.7494 27.3025 37.4689 27.8329 37.9993C28.3634 38.5297 29.0828 38.8277 29.8329 38.8277C30.5831 38.8277 31.3025 38.5297 31.8329 37.9993L40.4996 29.3326C41.5605 28.2718 42.1565 26.8329 42.1565 25.3326C42.1565 23.8323 41.5605 22.3935 40.4996 21.3326C39.4387 20.2718 37.9999 19.6758 36.4996 19.6758C34.9993 19.6758 33.5605 20.2718 32.4996 21.3326L23.8329 29.9993C22.2416 31.5906 21.3477 33.7489 21.3477 35.9993C21.3477 38.2497 22.2416 40.408 23.8329 41.9993C25.4242 43.5906 27.5825 44.4846 29.8329 44.4846C32.0834 44.4846 34.2416 43.5906 35.8329 41.9993L44.4996 33.3326"
          stroke="#000929"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1050_49676">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(16.5 16)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaperClipHome;
